import { module } from 'modujs';
import { Swiper, Pagination } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);

        this.carousel = this.$('carousel')[0]

        if (!this.carousel) {
            this.carousel = this.el
        }

        this.scrollbar = this.$('scrollbar')[0]
    }

    init() {
        this.length = this.$('item').length

        if (this.length > 1) {
            this.carousel = new Swiper(this.carousel, {
                modules: [
                    Pagination,
                ],
                speed: 300,
                loop: false,
                allowTouchMove: false,
                slidesPerView: 1,
            })
        }
    }

    goTo(index) {
        this.carousel.slideTo(index)
    }

    destroy() {
        if (this.carousel && this.carousel.destroy) {
            this.carousel.destroy(true, true)
        }
    }
}
